import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ce8cc46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white shadow user-container d-lg-flex flex-wrap" }
const _hoisted_2 = { class: "px-lg-4 py-lg-3 pt-2 pb-4 position-relative item d-flex border-bottom align-content-center" }
const _hoisted_3 = { class: "my-auto" }
const _hoisted_4 = { class: "d-flex justify-content-center align-content-center" }
const _hoisted_5 = { class: "d-flex flex-column align-content-center justify-content-center ms-3" }
const _hoisted_6 = {
  key: 0,
  class: "author text-white d-flex justify-content-center fw-bold fs-8 mb-2 align-items-center"
}
const _hoisted_7 = ["onClick"]

import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import Avatar from '@/components/avatar/index.vue'

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { translate } from '@/languages/i18n'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ACCOUNT_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'
import { computed, ref, reactive, nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  listUsers: Object,
},
  setup(__props) {


const route = useRoute()
const store = useStore()
const modal = ref()
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)
const modalSelected = ref(null)
const listModalProfile = reactive({
  alumni: PortfolioAlumni,
  employee: PortfolioUser,
})

const handleShowUser = async (id, userID, userType) => {
  modalSelected.value = null
  if (!listModalProfile[userType]) {
    return
  }
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType })
  modalSelected.value = userType
  await nextTick()
  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))
  if (showModal.value) {
    await modal.value?.show()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.listUsers?.users, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['col-lg-4 p-3', __props.listUsers?.member_number === 1 ? 'w-100' : 'item-user']),
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Avatar, {
                  is_deleted_in_30_days: item?.is_deleted_in_30_days,
                  user_image_url: item?.image_url,
                  userType: item?.user_type
                }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (item?.is_admin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(translate)('creator')), 1))
                : _createCommentVNode("", true),
              _createVNode(UserAliasIcon, {
                userType: item?.user_type
              }, null, 8, ["userType"]),
              _createElementVNode("div", {
                class: "fw-bold fs-7 mt-2 d-flex cursor-pointer",
                onClick: () => handleShowUser(_unref(route)?.params?.id, item?.id, item?.user_type)
              }, [
                _createElementVNode("span", null, _toDisplayString(item?.display_name), 1)
              ], 8, _hoisted_7)
            ])
          ])
        ], 2))
      }), 128))
    ]),
    (modalSelected.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(listModalProfile)[modalSelected.value]), { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})